import React from "react";
import { Redirect, withRouter, Route, Switch } from "react-router-dom";
import DocumentTitle from "react-document-title";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Layout } from "antd";
import { getMenuItemInMenuListByProperty } from "@/utils";
import { hasPermission } from "@/utils/permission";
import routeList from "@/config/routeMap";
import menuList from "@/config/menuConfig";
const { Content } = Layout;

const getPageTitle = (menuList, pathname) => {
  let title = "Plenty Health";
  let item = getMenuItemInMenuListByProperty(menuList, "path", pathname);
  if (item) {
    title = `${item.title}`;
  }
  return title;
};

// 根据用户角色找到第一个有权限访问的菜单项
const findFirstAccessibleRoute = (role) => {
  // 递归查找菜单项
  const findRoute = (items) => {
    for (const item of items) {
      // 检查当前菜单项是否有权限访问
      if (!item.roles || item.roles.includes(role)) {
        // 如果有子菜单，先检查子菜单
        if (item.children && item.children.length > 0) {
          const childRoute = findRoute(item.children);
          if (childRoute) return childRoute;
        }
        // 返回当前菜单项的路径
        return item.path;
      }
    }
    return null;
  };
  
  // 从菜单配置中查找
  const route = findRoute(menuList);
  return route || "/dashboard"; // 如果没找到，默认返回dashboard
};

const LayoutContent = (props) => {
  const { role, location } = props;
  const { pathname } = location;
  
  // 优化的路由权限过滤
  const handleFilter = (route) => {
    const hasAccess = hasPermission(role, route.roles);
    
    return hasAccess;
  };

  // 如果没有角色信息，显示加载中
  if (!role) {
    return (
      <Content style={{ 
        flex: 1, 
        height: "100%", 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        <div style={{ textAlign: 'center', color: '#999' }}>
          <h3>加载中...</h3>
          <p>正在验证用户权限</p>
        </div>
      </Content>
    );
  }

  return (
    <DocumentTitle title={getPageTitle(menuList, pathname)}>
      <Content style={{ flex: 1, height: "100%" }}>
        <TransitionGroup style={{ height: "100%" }}>
          <CSSTransition
            key={location.pathname} 
            timeout={500} // 动画时间
            classNames="fade" // 动画类名
            exit={false} // 是否退出动画
          >
            <div style={{ height: "100%" }}>
              <Switch location={location}>
                {/* 根据用户角色重定向到有权限的第一个菜单项 */}
                <Redirect exact from="/" to={findFirstAccessibleRoute(role)} />
                {routeList.map((route) => {
                  return (
                    handleFilter(route) && (
                      // 路由组件
                      <Route
                        component={route.component}
                        key={route.path}
                        path={route.path}
                      />
                    )
                  );
                })}
                {/* 如果所有路由都不匹配，检查是否为权限问题 */}
                <Route 
                  render={() => {
                    // 检查当前路径是否存在于路由配置中
                    const currentRoute = routeList.find(route => 
                      pathname.includes(route.path) || route.path === pathname
                    );
                    
                    if (currentRoute && !hasPermission(role, currentRoute.roles)) {
                      // 权限不足
                      const accessibleRoute = findFirstAccessibleRoute(role);
                      return (
                        <div style={{ 
                          padding: '50px', 
                          textAlign: 'center',
                          fontSize: '16px',
                          color: '#666'
                        }}>
                          <h3>🚫 权限不足</h3>
                          <p>您没有权限访问此页面</p>
                          <p>当前角色: <strong>{role}</strong></p>
                          <p>需要角色: <strong>{currentRoute.roles?.join(', ') || '未指定'}</strong></p>
                          <a href={`#${accessibleRoute}`}>返回可访问页面</a>
                        </div>
                      );
                    }
                    
                    // 页面不存在，跳转到404
                    return <Redirect to="/error/404" />;
                  }}
                />
              </Switch>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Content>
    </DocumentTitle>
  );
};

export default connect((state) => state.user)(withRouter(LayoutContent));
